import PropTypes from 'prop-types';

import { FLOW_CATEGORIES } from 'Pages/TeamDashboard/ProductLibrary/flowCategories';

import FlowDropdown from './FlowDropdown';

const CategoryDropdown = ({ value, onChange }) => {
  const categoryNames = FLOW_CATEGORIES.map(category => category.name);

  return (
    <FlowDropdown
      value={value}
      onChange={onChange}
      items={categoryNames}
      placeholder="Select category"
      triggerSize="large"
      showSearch={false}
    />
  );
};

CategoryDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CategoryDropdown.defaultProps = {
  value: '',
};

export default CategoryDropdown;
